import React from "react";
import { Modal, Spin, Tabs } from "antd";

import BasicInfoTab from "../BasicInfoTab/BasicInfoTab";
import ClassSubscribedTab from "../ClassSubscribedTab/ClassSubscribedTab";
import InvoicesTab from "../InvoicesTab/InvoicesTab";
import PaymentsTab from "../PaymentsTab/PaymentsTab";
import UserAccountsTab from "../UserAccountsTab/UserAccountsTab";
import UserEventsTab from "../UserEventsTab/UserEventsTab";

const StudentDetailsModal = ({ visible, onClose, student, loading }) => {
  return (
    <Modal
      title={`Student: ${student?.full_name || ""}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Spin spinning={loading}>
        {student && (
          <Tabs defaultActiveKey="1" type="card">
            <Tabs.TabPane tab="Basic Info" key="1">
              <BasicInfoTab student={student} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={`Class Subscribed (${student.class_subscribed?.length || 0})`} key="2">
              <ClassSubscribedTab data={student.class_subscribed} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={`Invoices (${student.invoices?.length || 0})`} key="3">
              <InvoicesTab data={student.invoices} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={`Payments (${student.payments?.length || 0})`} key="4">
              <PaymentsTab data={student.payments} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={`User Accounts (${student.user_accounts?.length || 0})`} key="5">
              <UserAccountsTab data={student.user_accounts} />
            </Tabs.TabPane>

            <Tabs.TabPane tab={`Events (${student.user_events?.length || 0})`} key="6">
              <UserEventsTab data={student.user_events} />
            </Tabs.TabPane>
          </Tabs>
        )}
      </Spin>
    </Modal>
  );
};

export default StudentDetailsModal;
